import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/device_model_firmware_versions?include=deviceModel,services`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/device_model_firmware_versions/${id}?include=deviceModel,services`, options)
        .then(response => {
            let deviceModelFirmwareVersion = jsona.deserialize(response.data);
            delete deviceModelFirmwareVersion.links;
            return deviceModelFirmwareVersion;
        });
}

function add(deviceModelFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceModelFirmwareVersion,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device_model_firmware_versions`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function multipleAdd(deviceFirmwareVersion) {
    // const payload = jsona.serialize({
    //     stuff: deviceFirmwareVersion,
    //     includeNames: null
    // });
    const payload = deviceFirmwareVersion;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-model-firmware-versions/multiple-add`, payload, options)
        .then(response => {
            return response.data;
        });
}

function update(deviceModelFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceModelFirmwareVersion,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/device_model_firmware_versions/${deviceModelFirmwareVersion.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/device_model_firmware_versions/${id}`, options);
}

export default {
    list,
    get,
    add,
    multipleAdd,
    update,
    destroy
};